import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cm-pied-de-page',

  template: `
    <div class="pied-de-page row">
        <div class="col-xs-4  col-md-3">
            <ul class="menu-reseaux-sociaux">
                <li><a href="https://www.youtube.com/user/mariedenazareth" target="_blank"> <i class="fa fa-youtube-play" aria-hidden="true"></i> </a> </li>
                <li><a href="https://www.facebook.com/MarieDeNazareth-364628506468/" target="_blank"> <i class="fa fa-facebook-square" aria-hidden="true"></i> </a> </li>
                <li><a href="https://twitter.com/MinuteAvecMarie" target="_blank"> <i class="fa fa-twitter-square" aria-hidden="true"></i> </a> </li>
                <!--<li><i class="fa fa-share-alt" aria-hidden="true"></i></li>-->
            </ul>
        </div>

        <div class="col-xs-8 col-md-6 text-center">
            <ul class="menu-centre">
                <li (click)="afficherMentionsLegales.emit()">Mentions légales</li>
                <li (click)="afficherAPropos.emit()">À propos</li>
                <!--<li> <a href="http://www.cartemarialedumonde.org/fr/contact" target="_blank"> Contact </a> </li>
                <li>Signaler un erreur</li>-->
                <li> <a href="http://www.mariedenazareth.com" target="_blank"> Marie de Nazareth </a></li>
            </ul>
        </div>

        <div class="col-md-3 hidden-sm hidden-xs text-right">
            <span class="texte-copyright">&copy; Association Marie de Nazareth, tous droits réservés, 2017</span>
        </div>
    </div>
  `,

  styles: [`
    .pied-de-page {
      width: 100vw;
      height: 50px;
      background-color: white;
      padding: 12px;
      font-size: 13px;
      color: #006296;
      font-weight: 700;
      border: 1px solid lightgray;
      margin-left: 0;
    }
    ul {
        display: inline;
        -webkit-padding-start: 0px;
    }
    li {
        display: inline;
        cursor: pointer;
    }
    img {
        height: 30px;
    }
    .menu-reseaux-sociaux {
        margin-top: -5px;
    }
    .menu-reseaux-sociaux li {
        margin-left: 20px;
    }
    .menu-centre {
        text-transform: uppercase;
    }
    .menu-centre li {
        margin-right: 20px;
    }
    .texte-copyright {
        margin-right: 40px;
    }
    .fa {
        font-size: 26px;
        color: #FFA300;
    }
    a {
        text-decoration: none;
    }

    @media (max-width: 1630px) { 
        .texte-copyright {
            font-size: 10px;
            margin-left: -100px;
        }
    }
  `]
})
export class PiedDePageComponent implements OnInit {
    @Output() afficherAPropos: EventEmitter<any> = new EventEmitter();
    @Output() afficherMentionsLegales: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pied-de-page.component.ts